// C10 (BIN01-S 3.1): checks for the XDIS91 korrespondance form.
// Subject is String_1_70 in ClinicalEmail.xsd; Communicate allows 3500 characters of Text01.

export const CORRESPONDENCE_SUBJECT_MAX = 70;
export const CORRESPONDENCE_TEXT_MAX = 3500;

export type CorrespondenceIssue = 'receiver' | 'subject' | 'text' | 'file' | 'zip' | 'cpr' | 'sender';

export function correspondenceIssues(input: {
  hasReceiver: boolean;
  subject: string;
  text: string;
  hasFile: boolean;
  zipTypeMissing: boolean;
  hasCpr: boolean;
  hasSender: boolean;
}): CorrespondenceIssue[] {
  const issues: CorrespondenceIssue[] = [];
  if (!input.hasSender) issues.push('sender');
  if (!input.hasCpr) issues.push('cpr');
  if (!input.hasReceiver) issues.push('receiver');
  if (input.subject.trim().length > CORRESPONDENCE_SUBJECT_MAX) issues.push('subject');
  if (input.text.trim().length === 0 || input.text.length > CORRESPONDENCE_TEXT_MAX) issues.push('text');
  if (!input.hasFile) issues.push('file');
  if (input.zipTypeMissing) issues.push('zip');
  return issues;
}
